import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { Box, FormControlLabel, Checkbox, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const CostoTransporteVentasBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = [
    'Servicios logísticos', 
    'Automotriz', 
    'Manufactura', 
    'Alimentos', 
    'Construcción', 
    'Salud/Farmacéutica', 
    'Retail'
  ];

  const costData2023 = {
    'Servicios logísticos': 19,
    'Automotriz': 7,
    'Manufactura': 4,
    'Alimentos': 5,
    'Construcción': 5,
    'Salud/Farmacéutica': 4,
    'Retail': 3,
  };

  const costData2024 = {
    'Servicios logísticos': 13,
    'Automotriz': 2,
    'Manufactura': 3,
    'Alimentos': 9,
    'Construcción': 11,
    'Salud/Farmacéutica': 8,
    'Retail': 4,
  };

  const colorMap = {
    '2022': '#717171', // gris más oscuro
    '2023': '#1F3D58', // azul oscuro
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const dataValues2023 = labels.map((label) => costData2023[label]);
  const dataValues2024 = labels.map((label) => costData2024[label]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Costo de Transporte (%) (2022)',
        data: dataValues2023,
        backgroundColor: colorMap['2022'],
        borderColor: '#fff',
        borderWidth: 2,
      },
      {
        label: 'Costo de Transporte (%) (2023)',
        data: dataValues2024,
        backgroundColor: colorMap['2023'],
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}%`,
        },
      },
      datalabels: {
        color: '#FFFFFF', // Números en blanco
        font: {
          weight: 'bold',
          size: 14,
        },
        anchor: 'center',
        align: 'center',
        formatter: (value) => `${value}`,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
          
        },
        ticks: {
          autoSkip: false,
        },
      },
      y: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 20,
        ticks: {
          stepSize: 5,
          color: '#FFFFFF', // Cambiar números del eje Y a blanco
        },
      },
    },
    onClick: (evt, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const industry = chartData.labels[index];
        handleSegmentClick(industry);
      }
    },
  };

  const handleSegmentClick = (industry) => {
    let updatedSelectedIndustries = [...selectedIndustries];
    if (updatedSelectedIndustries.includes(industry)) {
      updatedSelectedIndustries = updatedSelectedIndustries.filter((item) => item !== industry);
    } else {
      updatedSelectedIndustries.push(industry);
    }
    onBarClick(updatedSelectedIndustries);
  };

  const handleCheckboxChange = (industry) => {
    handleSegmentClick(industry);
  };

  const infoContent = {
    Analisis: 'Se observa una reducción destacada en Servicios logísticos (del 19% al 13%) y en Automotriz (del 7% al 2%) durante el 2023 lo que podría indicar mayor eficiencia operativa o renegociación de tarifas de transporte.',
    formula: 'Costo de Transporte (%) = Costo de transporte como % de las ventas totales',
    description: 'La gráfica muestra la proporción que representa el costo de transporte en relación con las ventas totales por industria en 2023',
  };
  

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Box display="flex" justifyContent="center" flexWrap="wrap" mb={2}>
        {allLabels.map((industry) => (
          <FormControlLabel
            key={industry}
            control={
              <Checkbox
                checked={selectedIndustries.includes(industry)}
                onChange={() => handleCheckboxChange(industry)}
                color="primary"
              />
            }
            label={industry}
          />
        ))}
      </Box>
      <div style={{ width: '100%', height: '325px' }}>
        <Bar data={chartData} options={options} />
      </div>
  
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
  
};

export default CostoTransporteVentasBar;
